import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OpenInAssetSidebarButtonComponent } from './open-in-asset-sidebar-button.component';

@NgModule({
  declarations: [OpenInAssetSidebarButtonComponent],
  exports: [OpenInAssetSidebarButtonComponent],
  imports: [CommonModule, MatButtonModule, MatTooltipModule, MatIconModule, FontAwesomeModule],
})
export class OpenInAssetSidebarButtonModule {}
